import { Navigate, Outlet } from "@tanstack/react-router";
import { useLogout, useMe } from "@/lib/auth";
import { Footer } from "./Footer";
import { Sidebar } from "./Sidebar";
import { Skeleton } from "./ui/skeleton";

/** Authenticated shell: sidebar + page content + required footer. */
export function AppLayout() {
  const me = useMe();
  const logout = useLogout();

  if (me.isLoading) {
    return (
      <div className="flex h-screen">
        <div className="w-60 border-r bg-bg-secondary p-4" style={{ borderColor: "var(--accent-subtle)" }}>
          <Skeleton className="mb-8 h-12" />
          {Array.from({ length: 6 }).map((_, i) => (
            <Skeleton key={i} className="mb-3 h-9" />
          ))}
        </div>
        <div className="flex-1 p-8">
          <Skeleton className="mb-6 h-8 w-64" />
          <Skeleton className="h-40" />
        </div>
      </div>
    );
  }

  if (me.isError || !me.data) {
    return <Navigate to="/login" />;
  }

  return (
    <div className="flex h-screen overflow-hidden">
      <Sidebar user={me.data} onLogout={() => logout.mutate()} />
      <div className="flex min-w-0 flex-1 flex-col overflow-y-auto">
        <main className="flex-1 px-8 py-6">
          <Outlet />
        </main>
        <Footer />
      </div>
    </div>
  );
}
